import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import NumberInput from '../../../../../../common/inputs/numberInput/NumberInput'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../../../objectDetails/fields/common/PopoverContent'
import { formatNumber } from '../../../../../../../i18next/decimal'

interface CalculatedTotalRentProps extends FieldProps<CostsScreenValidationResult> {
  calculatedValue?: number
  disabled?: boolean
}

const TotalRent: React.FC<CalculatedTotalRentProps> = ({
  screenName,
  onChange,
  calculatedValue,
  disabled = true,
  wrapperClassName = 'grid-item one-whole margin-top-l',
}) => {
  const { t } = useTranslation()

  const labelWithTooltip = (
    <LabelWithTooltip
      inputId='calculated-total-rent'
      labelText={t('wizard.screen.costs.costCalculation.totalRent')}
      tooltipContent={<PopoverContent translationKey='wizard.screen.costs.calculatedTotalRentHint' />}
      showMandatory={false}
    />
  )

  return (
    <div className={wrapperClassName}>
      {labelWithTooltip}
      <NumberInput
        id='calculated-total-rent'
        propertyName='manualTotalRent'
        placeholder=''
        value={calculatedValue}
        minPrecision={0}
        maxPrecision={2}
        maxLength={14}
        affixRight='unit'
        unitRight='eur'
        disabled={disabled}
        errors={[]}
        doOnFieldChange={(property, value) => {
          onChange({ screen: screenName, property }, formatNumber(value))
        }}
      />
    </div>
  )
}

export default TotalRent
